<template>
  <div id="project-view">
    <div class="content">
      <div class="content__inner">
        <project-view-item
          v-for="item in currentItem($route.params.id)"
          v-bind:key="item.post_name"
          v-bind:item="item"
        ></project-view-item>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectViewItem from '../components/ProjectViewItem.vue';

export default {
  name: 'ProjectView',
  methods: {
    currentItem: function(id) {
      // console.log('CURRENT ITEM :: ', id);

      if (id === 'RECUR') {
        return [
          {
            post_title: 'RECUR',
            acf: {
              oneoff_title: 'RECUR Case Study and mobile application prototype',
              short_description:
                'I worked on a wide array of marketing communications to drive consumer conversions on the restaurant-centric platform.',
              long_description:
                'As a marketer, I am always striving to create better digital experiences for consumers, so I decided to enroll in a user experience design (UXD) course from a recognized school in order to refine the design thinking strategies I consistently put into practice. <br>As a part of this case study, I ideated, researched, and built a mobile application prototype for a loyalty haircare platform called RECUR.<br> Consumers would opt in to the network to take advantage of the savings, while businesses operate in parallel on a RECUR Content Management System (CMS) to create and maintain profiles, advertise new service offerings, and offer personalized discounts, which will build brand equity and illicit consumer loyalism. Additionally, RECUR could offer service providers cost-effective marketing solutions to help acquire and retain consumers (i.e. SEO optimization, website design, email marketing, and social media campaigns).<br> Among my conclusions, I found that a business opportunity exists to consolidate small business service providers into one RECUR network, allowing them to provide financial incentives to consumers in exchange for repeat haircut business. After an onboarding period, the network could expand to include other service offerings (i.e. hair colorings, manicures, pedicures, tanning services, etc.) that consumers frequent on a repeat basis. There is substantial data to support that these services do not offer repeat discounts to consumers, so the expansion of a RECUR network would be financially viable.<br> Below is the design thinking process for the RECUR product along with the final mobile application prototype.',
              category: 'Tech',
              button_text: 'View More Work',
              brand_logo: 'https://adamfleishman.com/img/RECUR_Logo.png',
              header_image: {
                sizes: {
                  large: 'https://adamfleishman.com/img/recur-topbar.png'
                }
              },
              detail_groups: [
                {
                  group_items: [
                    {
                      section_title: '',
                      number_of_columns: '1',
                      section_items: [
                        { image: 'https://adamfleishman.com/img/cs_0000_1.jpg' },
                        { image: 'https://adamfleishman.com/img/cs_0001_2.jpg' },
                        { image: 'https://adamfleishman.com/img/cs_0002_3.jpg' },
                        { image: 'https://adamfleishman.com/img/cs_0003_4.jpg' },
                        { image: 'https://adamfleishman.com/img/cs_0004_5.jpg' },
                        { image: 'https://adamfleishman.com/img/cs_0005_6.jpg' },
                        { image: 'https://adamfleishman.com/img/cs_0006_7.jpg' },
                        { image: 'https://adamfleishman.com/img/cs_0007_8.jpg' }
                      ]
                    }
                  ]
                }
              ]
            }
          }
        ];
      }

      console.log(
        this.$root.projectsData.filter(obj => {
          return obj.post_name == id ? obj : false;
        })
      );

      return this.$root.projectsData.filter(obj => {
        return obj.post_name == id ? obj : false;
      });
    }
  },
  components: {
    'project-view-item': ProjectViewItem
  }
};
</script>
